module.exports = __webpack_public_path__ + "static/media/4.907e500e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/mogilev/4.jpg
// module id = 237
// module chunks = 0